import type { StepResult } from '@/pages/TechChecks/models';

const SMOKE_STATE_ICONS: Record<StepResult['state'], string> = {
  pending: '·',
  running: '…',
  ok: '✓',
  failed: '✗',
  skipped: '–',
};

const SmokeTestProgress = ({ results }: { results: StepResult[] }) => (
  <div className='rounded-md border border-blue-100 bg-blue-50 p-3'>
    <p className='mb-1 text-xs font-medium text-blue-800'>Pruebas en test en curso</p>
    <ul className='flex flex-col gap-0.5 text-xs text-gray-800'>
      {results.map((result) => (
        <li key={result.stepId}>
          {SMOKE_STATE_ICONS[result.state]} {result.name}
          {result.status !== null ? ` — ${result.status} (${result.ms} ms)` : ''}
          {result.error ? ` — ${result.error}` : ''}
        </li>
      ))}
    </ul>
  </div>
);

export default SmokeTestProgress;
